/**
 * Helper function to show warning in the console during development
 * @param {expression} assert - assertion to test
 * @param {string} scope - location of the warning, usually a component
 * @param {string} message - instructions about the warning
 */
export function warn(assert: boolean, scope: string, message: string) {
  if (import.meta.env.NODE_ENV !== 'production') {
    if (assert) {
      if (console.warn) {
        console.warn(`AtpLib [${scope}]: ${message}`);
      } else {
        console.log(`AtpLib [${scope}]: ${message}`);
      }
    }
  }
}
